import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import {Helmet} from 'rnd-helmet';
import {injectIntl} from "react-intl";
import Form from 'form';
import dispatchRerender from 'dispatchRerender';
import { pushCandidateEvent, useDataLayer } from "dataLayerHelper";
import FormContext from "formContext";
import GetRouteByName from 'getRouteByName';
import SubMenu from "@Components/SubMenu";
import Icon from "@Components/Icon";
import NoticeInPage from "@Components/NoticeInPage";
import NoticeInPageCutover from "@Components/NoticeInPageCutover";

function Login({intl, staticContext, location}) {
  const urlMessageParam = new URLSearchParams(location.search).get('message');
  const { locale } = intl;
  const {formData, setFormData, handleErrors, currentStep, showToast, setToastMessage, handleChange, setLoading, additionalData} = useContext(FormContext);
  const [showConfirmation, setConfirmation] = useState(urlMessageParam);
  const dashboardUrl = GetRouteByName('dashboard').url;
  const forgotPasswordUrl = GetRouteByName('forgot-password').url;
  const cutoverMrndLoginSettings = additionalData?.cutoverSettings?.myrandstad_login || {};

  const headerTitleLeft = intl.formatMessage({id: "Login.Header.Title.Left"});
  const headerTitleRight = intl.formatMessage({id: "Login.Header.Title.Right"});

  const noticeSettings = {
    type: 'informative',
    message: intl.formatMessage({id: "Login.NoticeInPage.PasswordExpiration.Text"}, { url: forgotPasswordUrl })
  }

  // Generate dataLayer for the page.
  useDataLayer(locale, staticContext);

  useEffect(() => {
    if (window.location.hash === "#toast=logged-out") {
      setToastMessage(intl.formatMessage({id: 'Login.LoggedOut.Text'}));
      showToast();
    }
    dispatchRerender();
    setFormData([]);
  }, []);

  const handleSubmit = event => {
    event.preventDefault();
    setLoading(true);

    // Fetch saved jobs.
    const favoriteJobs = JSON.parse(localStorage.getItem("favJobs"));
    if (favoriteJobs && formData[currentStep]) {
      formData[currentStep].savedJobs = favoriteJobs;
    }

    if (captcha?.getToken('mrnd_captcha')) {
      if (!formData[currentStep]) {
        formData[currentStep] = {};
      }
      formData[currentStep].captchaToken = captcha?.getToken('mrnd_captcha');
    }

    axios.post(`${process.env.REACT_APP_API_PREFIX}/login`, formData[currentStep])
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          pushCandidateEvent("login");

          window.location = dashboardUrl;
          setLoading(false);
          captcha?.reset('mrnd_captcha');
        }
      })
      .catch(error => {
        handleErrors(error.response.data);
        setLoading(false);
        captcha?.reset('mrnd_captcha');
      });
  };

  const renderConfirmation = () => {
    if (!showConfirmation) {
      return '';
    }
    return (
      <div
        className={`block notice-confirmed closable bg-variant-brand-quaternary notification-type-${showConfirmation}`}
        data-rs-hours-confirmed-notification-1=""
      >
        <div className="wrapper notice-confirmed__wrapper">
          <div className="notice-confirmed__media" data-rs-closable-fadeout="">
            {showConfirmation === "confirmed" && <img src='/myrandstad-app/assets/image/icons/illustration-hand-1a.svg' alt=""/>}
            {showConfirmation === "reset" && <img src='/myrandstad-app/assets/image/icons/illustration-medal.svg' alt=""/>}
          </div>
          <div className="notice-confirmed__content">
            <div className="notice-confirmed__text" data-rs-closable-fadeout="">
              {showConfirmation === "confirmed" && <p>{intl.formatMessage({id: 'Login.Message.AccountWasVerified'})}</p>}
              {showConfirmation === "reset" && <p>{intl.formatMessage({id: 'Login.Message.ResetPasswordSuccessful'})}</p>}
            </div>
            <div className="notice-confirmed__close">
              <button className="button--icon-only" onClick={() => setConfirmation('')} aria-label={intl.formatMessage({ id: "Close" })}>
                <Icon type="close-30" className="icon icon--inline" />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'Login.Meta.Title'})} | {intl.formatMessage({id: 'Page.Opcolabel.MetaTitle'})}</title>
        <meta name="description" content={intl.formatMessage({id: 'Login.Meta.Description'})} />
        <header className="header header--text bg-variant-brand-primary"/>
      </Helmet>
      <div className="header header--text bg-variant-brand-primary">
        <div className="header__wrapper wrapper">
          <SubMenu />
          <div className="header__content header__content--l content-block header__content--full-width has-breadcrumbs">
            <h1 className="content-block__title">
              <span className="content-block__title-top">{headerTitleLeft}</span>
              <span className="content-block__title-bottom text--emphasis">{headerTitleRight}</span>
            </h1>
          </div>
        </div>
      </div>
      <div className="block block--xs">
	      <div className="wrapper block__wrapper">
          <NoticeInPage settings={noticeSettings} style={{maxWidth: '100%'}} />
        </div>
      </div>
      <NoticeInPageCutover settings={cutoverMrndLoginSettings} />
      {renderConfirmation()}
      <Form name='login' handleChange={handleChange} state={formData[currentStep]} handleSubmit={handleSubmit} />
    </>
  )
}

export default injectIntl(Login);
